import Vue from 'vue'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import authentication from './authentication'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false

// Setup axios as the Vue default $http library
Vue.prototype.$http = axios
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_URL

// Silently retrieve the access token before each API call so requests always carry a valid bearer.
// When valid token: "synchronous" token retrieval through localStorage (getCachedToken)
// When expired token: trigger the hidden-iframe renewal (acquireToken) and wait for the new token to be returned.
// Regex is used to prevent external requests outside of the app url (MySwarco).
axios.interceptors.request.use(async (config) => {
  const url = config.url || ''
  if (/^https?:\/\//i.test(url)) return config
  let token = authentication.getCachedToken()
  if (!token) {
    try {
      token = await authentication.acquireToken()
    } catch (e) {
      console.warn('silent token refresh failed', e) /* eslint-disable-line no-console */
      // Do not let Axios fall back to its default Authorization header: it can contain
      // the expired bearer from the previous session and would send a misleading 401
      config.headers = config.headers || {}
      delete config.headers.Authorization
      throw e instanceof Error ? e : new Error(String(e))
    }
  }
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const moment = require('moment')
require('moment/locale/nl')
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

console.debug('version:' + process.env.VUE_APP_VERSION); /* eslint-disable-line no-console */
Vue.prototype.$version = process.env.VUE_APP_VERSION;
console.debug('locale: ' + Vue.moment().locale()) /* eslint-disable-line no-console */

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
var printMediaQuery = window.matchMedia('print');

// Init adal authentication - then create Vue app.
// eslint-disable-next-line
authentication.initialize().then(_ => {

  /* eslint-disable no-new */
  new Vue({
    router,
    axios,
    vuetify,
    render: h => h(App),
    data: () => ({
      me: null,
      scPermissions: [],
      baseOrganizations: [],
      organization: null,
      profilePhoto: null,
      graphToken: null,
      dialogErrorCode: null,
      dialogMessage: null,
      dialogConfirm: null,
      dialogConfirmResolve: null,
      emptyGuid: "00000000-0000-0000-0000-000000000000",
      phoneRegex: /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^00[0-9]{2}|^0)([0-9\-\s]{8,12}$)/,
      isPrinting: false,
      appDrawer: true,
      fetchingPermissions: false,
      /* must match the enum in models! */
      statusTypes: [
        { id: 0, name: "Aangemaakt", disableOnOpenTasks: false, color: '#FF0000' },
        { id: 1, name: "In behandeling", disableOnOpenTasks: false, color: '#ffc34d' },
        { id: 2, name: "Onderzoek", disableOnOpenTasks: false, color: '#12b0db' },
        { id: 3, name: "Inplannen", disableOnOpenTasks: false, color: '#1186a6'},
        { id: 4, name: "Gepland", disableOnOpenTasks: false, color: 'primary' },
        { id: 5, name: "Oplossen", disableOnOpenTasks: false, color: '#b5f27c' },
        { id: 6, name: "Wachten op melder", disableOnOpenTasks: false, color: '#ed51d0' },
        { id: 7, name: "Wachten op leverancier", disableOnOpenTasks: false, color: '#a1338c' },
        { id: 8, name: "Afgehandeld", disableOnOpenTasks: false, color: '#32CD32'},
        { id: 9, name: "Controle", errorMessage: "Er zijn nog openstaande taken en/of ongeboekte materiaal verbuiken", disableOnOpenTasks: true, color: 'primary' },
        { id: 10, name: "Factureren", errorMessage: "Er zijn nog openstaande taken en/of ongeboekte materiaal verbuiken", disableOnOpenTasks: true, color: '#2444bd' },
        { id: 11, name: "Gesloten", errorMessage: "Er zijn nog openstaande taken en/of ongeboekte materiaal verbuiken", disableOnOpenTasks: true, color: '#289e5e'  },
        { id: 12, name: "Gearchiveerd", errorMessage: "Er zijn nog openstaande taken en/of ongeboekte materiaal verbuiken", disableOnOpenTasks: true, color: '#21854f' },
      ],
      /* must match the enum in models! */
      impacts: [
        { id: 0, name: "Geen" },
        { id: 1, name: "Laag", color: "primary" },
        { id: 2, name: "Medium", color: "warning" },
        { id: 3, name: "Hoog", color: "red" },
      ],
      priorities: [
        { id: 0, name: 'Geen', icon: "mdi-circle-medium" },
        { id: 1, name: 'Laag', icon: "mdi-chevron-down", color: "primary" },
        { id: 2, name: 'Medium', icon: "mdi-equal", color: "warning" },
        { id: 3, name: 'Hoog', icon: "mdi-chevron-up", color: "red" },
      ],
      /* must match the enum in models! */
      projectTypes: [
        { id: 0, name: 'Administratief' },
        { id: 1, name: 'Productontwikkeling' },
        { id: 2, name: 'Reservering' },
        { id: 3, name: 'Contract' }
      ],
      /* must match the enum in models! */
      projectScopes: [
        { id: null, name: '' },
        { id: 0, name: 'Nieuwbouw' },
        { id: 1, name: 'Wijziging' },
        { id: 2, name: 'Consolidatie' },
        { id: 3, name: 'A Compilatie' },
        { id: 4, name: 'B Compilatie' },
        { id: 5, name: 'C Compilatie' },
        { id: 6, name: 'Onderhoudscontract' },
        { id: 7, name: 'Preventief onderhoud' },
        { id: 8, name: 'Losse leveringen' }
      ],
      /* must match the enum in models! */
      hourbookingTypes: [
        { id: 0, name: 'Direct' },
        { id: 1, name: 'Indirect' },
        { id: 2, name: 'Ziekte' },
        { id: 3, name: 'Parttime' },
        { id: 4, name: 'Feestdagen' },
        { id: 5, name: 'Verlof standaard' },
        { id: 6, name: 'Verlof bijzonder' },
        { id: 7, name: 'Verlof gekocht' },
        { id: 8, name: 'Verlof compensatie' },
        { id: 9, name: 'Verlof restant vorige periode' },
        { id: 11, name: 'Buffer' },
      ],
      hourbookingStatuses: [
        { id: 0, name: 'Aanvraag', color: '#81D4FA' },
        { id: 1, name: 'Gepland', color: '#e7ffd4' },
        { id: 2, name: 'Geboekt', color: '#d4ffde' },
        { id: 3, name: 'Goedgekeurd', color: '#6fd687' },
        { id: 4, name: 'Geannuleerd', color: '#e36d6d' },
      ],
      /* must match the enum in models! */
      ioTypes: [
        { id: 0, name: 'Overig' },
        { id: 1, name: 'Detector' },
        { id: 2, name: 'Overige input' },
        { id: 3, name: 'Signaalgroep' },
        { id: 4, name: 'Overige output' },
        { id: 5, name: 'Overige output inverted' },
        { id: 6, name: 'Output wachtsignaal' },
        { id: 7, name: 'Softwareflag' },
        { id: 8, name: 'Softwareflag error' },
        { id: 9, name: 'Softwareflag inverted error' },
        { id: 10, name: 'Softwareflag wachtsignaal' },
        { id: 11, name: 'Timer' },
        { id: 12, name: 'Parameter' },
        { id: 13, name: 'Counter' },
        { id: 14, name: 'Overige output error' },
        { id: 15, name: 'Overige output inverted error' },
        { id: 16, name: 'Overige output wachtsignaal' },
      ],
      ioShapes: [
        { id: 0, title: 'Niet verklikken', icon: 'mdi-cancel', showMissingShapeWarning: false },
        { id: 1, title: 'Verklikken als polygoon', icon: 'mdi-vector-polygon', showMissingShapeWarning: true },
        { id: 2, title: 'Verklikken als cirkel', icon: 'mdi-circle-outline', showMissingShapeWarning: true },
        { id: 3, title: 'Verklikken als nummer', icon: 'mdi-numeric', showMissingShapeWarning: false }
      ],
      ioModes: [
        { id: 0, name: 'CCOL' },
        { id: 1, name: 'WTV/VMS' },
        { id: 2, name: 'CCOL+ITS'},
      ],
      organizationTypes: [
        { id: 0, name: "Tree node", enable: false },
        { id: 1, name: "Interne organisatie", enable: true, icon: 'mdi-sitemap-outline' },
        { id: 2, name: "Klanten", enable: true, icon: 'mdi-handshake-outline' },
        { id: 3, name: "Leveranciers", enable: true, icon: 'mdi-cart-outline' },
        { id: 3, name: "Aannemers", enable: true },
      ],
      ticketTypes: [
        { id: 0, name: 'Storing', description: 'Storing / correctief onderhoud. Indien de installatie onderdeel is van een SLA is deze van toepassing.' },
        { id: 1, name: 'Informatieverzoek', description: 'Voor het stellen van vragen of opvragen van gegevens. SLA niet van toepassing.' },
        { id: 2, name: 'Wijziging', description: 'Geen storing maar een wijziging op een bestaande installatie.' },
        { id: 3, name: 'Preventief onderhoud', description: '' }
      ],
      ticketSourceTypes: [
        { id: 0, name: 'Onbekend' },
        { id: 1, name: 'Telefoon' },
        { id: 2, name: 'Email' },
        { id: 3, name: 'MySwarco' },
        { id: 4, name: 'Klantportaal' },
        { id: 5, name: 'Asset Monitor' }
      ],
      personEvents: [
        { type: 0, name: "Algemeen", class: "white--text", descriptionRequired: true, isPersonEvent: true, color: '#9E9E9E' },
        { type: 1, name: "Consignatiedienst", class: "white--text", descriptionRequired: false, isPersonEvent: true, color: '#FF9800' },
        { type: 2, name: "Storingsdienst", class: "white--text", descriptionRequired: false, isPersonEvent: true, color: '#485156' },
        { type: 3, name: "TFO dienst", class: "white--text", descriptionRequired: false, isPersonEvent: true, color: '#006BAC' },
        { type: 4, name: "Support dienst", class: "white--text", descriptionRequired: false, isPersonEvent: true, color: '#702963' },
      ],
      productTypes: [
        { id: 0, name: 'Onbekend' },
        { id: 1, name: 'TLC' },
        { id: 2, name: 'ITS' },
        { id: 3, name: 'RIS' },
      ],
      projectStatusTypes: [
        { id: 0, name: "Applied", color: "primary" },
        { id: 1, name: "Estimation", color: "primary" },
        { id: 2, name: "Offered", color: "primary" },
        { id: 3, name: "Order", color: "primary" },
        { id: 4, name: "Preperation", color: "primary" },
        { id: 5, name: "Production", color: "primary" },
        { id: 6, name: "TechnicalFinished", color: "success" },
        { id: 7, name: "InvoicingAllowed", color: "primary" },
        { id: 8, name: "AdministrativeFinished", color: "success" },
        { id: 9, name: "Finished", color: "success" },
        { id: 10, name: "Expired", color: "error" },
        { id: 11, name: "Closed", color: "success" },
        { id: 12, name: "Archive", color: "success" },
        { id: 13, name: "Archived", color: "success" },
      ],
      installationMonitoringStatus: [
        { id: 0, icon: 'mdi-minus', color: 'grey', title: 'Onbekend', name: 'Unknown' },
        { id: 1, icon: 'mdi-check-circle', color: 'green', title: 'Ok', name: 'OK' },
        { id: 2, icon: 'mdi-alert-circle-outline', color: 'orange', title: 'Waarschuwing', name: 'Warning' },
        { id: 3, icon: 'mdi-close-circle', color: 'red', title: 'Alarm', name: 'NotOk' }
      ],
      ticketLinkTypes: [
        { id: 0, name: 'Geen' },
        { id: 1, name: 'Vervolg van' },
        { id: 2, name: 'Gerelateerd aan' },
        { id: 3, name: 'Duplicaat van' },
        { id: 4, name: 'Geblokkeerd door' }
      ],
      monitoringTaskTypes: [
        { id: 0, name: 'Geen' },
        { id: 1, name: 'Verbinding' },
        { id: 2, name: 'IVERA TLC' },
        { id: 3, name: 'IVERA ITS' },
        { id: 4, name: 'IVERA RIS' },
        { id: 5, name: 'VLOG' },
        { id: 6, name: 'UDAP/TLEX' }
      ],
      ticketIncidentSeverity: [
        { id: 0, name: 'Geen', color: '' },
        { id: 1, name: 'Alleen monitoring', color: 'primary' },
        { id: 2, name: 'Niet fataal', color: 'warning' },
        { id: 3, name: 'Fataal', color: 'error' }
      ],
      checklistStatus: [
        { id: 0, name: "Aangemaakt", color: 'warning' },
        { id: 1, name: "Inplannen", color: 'primary' },
        { id: 2, name: "Gepland", color: 'primary' },
        { id: 3, name: "In uitvoering", color: 'success' },
        { id: 4, name: "Controle", color: 'success' },
        { id: 5, name: "Afgerond", color: 'success' }
      ],
      supportTypes: [
        { id: 0, name: 'Geen' },
        { id: 1, name: 'Eerste lijn' },
        { id: 2, name: 'Tweede lijn' },
        { id: 3, name: 'Netwerk leverancier' }
      ],
      escalationMethods: [
        { id: 0, name: 'Geen' },
        { id: 1, name: 'Email' },
        { id: 2, name: 'MySwarco' },
        { id: 3, name: 'Extern System'}
      ],
      installationStatuses: [
        { id: 0, name: 'Created' },
        { id: 1, name: 'Planned' },
        { id: 2, name: 'Built'},
        { id: 3, name: 'Configured'},
        { id: 4, name: 'Tested'},
        { id: 5, name: 'FactoryAcceptanceTested'},
        { id: 6, name: 'Shipped'},
        { id: 7, name: 'Installed'},
        { id: 8, name: 'SiteAcceptanceTested'},
        { id: 9, name: 'Operational'},
        { id: 10, name: 'InService'},
        { id: 11, name: 'Maintained'},
        { id: 12, name: 'Updated'},
        { id: 13, name: 'Decommissioned'},

      ],
      caoCodes: ['INLEEN', 'INFRA', 'PMT', 'PME'],
      tokenExpire: null
    }),
    computed: {
      myName() {
        if (this.me) {
          return ((this.me.firstname || '') + ' ' + (this.me.surnamePrefix || '') + ' ' + (this.me.surname || '')).replace('  ', ' ')
        } else {
          return null
        }
      },
      isAuthenticated() {
        return authentication.isAuthenticated() ? (
          authentication.getUserProfile().roles &&
          authentication.getUserProfile().roles.length > 0 &&
          authentication.getUserProfile().roles.includes('User')) : false
      },
      isAdmin() {
        return authentication.isAuthenticated() ? (
          authentication.getUserProfile().roles &&
          authentication.getUserProfile().roles.length > 0 &&
          authentication.getUserProfile().roles.includes('Admin')) : false
      },
      myPermissions() {
        return this.me ? this.me.permissions : []
      },
      myNotifications() {
        return this.me ? this.me.notifications.map(x => x.notificationName) : []
      },
      myScPermissions() {
        return this.scPermissions.map(scp =>
        ({
          id: scp.serviceCategory.id,
          name: scp.serviceCategory.name,
          canCreate: scp.canCreate,
          canReadWrite: scp.canReadWrite,
          canManage: scp.canManage
        }))
      }
    },
    methods: {
      openConfirmDialog(title, message, type) {
        this.dialogConfirm = { title, message, type };
        return new Promise((resolve) => {
          this.dialogConfirmResolve = resolve;
        });
      },
      agreeConfirmDialog() {
        this.dialogConfirmResolve(true);
      },
      cancelConfirmDialog() {
        this.dialogConfirmResolve(false);
        this.clearConfirmDialog();
      },
      clearConfirmDialog() {
        this.dialogConfirm = null;
      },
      getProfileData() {
        this.$http
          .get('api/organization/base')
          .then(request => {
            this.organization = request.data;
            this.$http.get('api/employee')
              .then(request => {
                this.me = request.data;
                this.getBaseOrganizations();
                this.getPermissions();
                this.getScPermissions();
              })
              .catch((e) => {
                console.error('employee error!')  /* eslint-disable-line no-console */
                console.debug(e)  /* eslint-disable-line no-console */
              }
              )
          })
          .catch((e) => {
            console.error('organization error!')  /* eslint-disable-line no-console */
            console.debug(e) /* eslint-disable-line no-console */
          }
          )
      },
      async getPermissions() {
        try {
          this.fetchingPermissions = true;
          let result = await this.$http.get('api/employee/permissions');
          this.me.permissions = result.data;
        } catch(e) {
          console.error('permission error!')  /* eslint-disable-line no-console */
          console.debug(e)  /* eslint-disable-line no-console */
        } finally {
          this.fetchingPermissions = false;
        }
        
      },
      getScPermissions() {
        this.$http.get('api/employee/servicecategorypermissions')
          .then(request => {
            this.scPermissions = request.data
          })
          .catch((e) => {
            console.error('service category permission error!')  /* eslint-disable-line no-console */
            console.debug(e)  /* eslint-disable-line no-console */
          })
      },
      getBaseOrganizations() {
        this.$http.get('api/employee/baseorganizations')
          .then(request => {
            this.baseOrganizations = request.data;
            this.$root.$emit('baseOrgsLoaded', '');
          })
          .catch((e) => {
            console.error('base organizations error!')  /* eslint-disable-line no-console */
            console.debug(e)  /* eslint-disable-line no-console */
          })
      },
      getProfileImage() {
        this.$http.get('https://graph.microsoft.com/v1.0/me/photo/$value', { headers: { Authorization: this.graphToken }, responseType: 'arraybuffer' })
          .then(request => {
            this.setProfilePhoto(request.data)
          })
          .catch((e) => { console.log('profile photo error!' + e) }) /* eslint-disable-line no-console */
      },
      setProfilePhoto(photo) {
        var bytes = new Uint8Array(photo)
        var binary = bytes.reduce((data, b) => data += String.fromCharCode(b), '')
        this.profilePhoto = "data:image/jpeg;base64," + btoa(binary)
      },
      logOut() {
        authentication.signOut()
      },
      clearDialog() {
        this.dialogErrorCode = null;
        this.dialogMessage = null;
      },
      getSlaString(response) {
        if (response === null || response === undefined) return "nvt"
        else if (response.trim().includes("TBD")) return "In overleg"
        else if (response.trim().includes("NBD")) return "vlgd wd"
        else if (response.trim().includes("BD")) return response.replace("BD", "wd")
        else if (response.trim().includes("D")) return response.replace("D", "d")
        else if (response.trim().includes("OH")) return response.replace("OH", "u binnen kantoortijden")
        else if (response.trim().includes("H")) return response.replace("H", "u")
        else if (response.trim().includes("SC")) return "Zie contract"
      },
      projectTypeById(id) {
        var result = this.projectTypes.find(x => x.id == id);
        if (!result) return '';
        return result.name;
      },
      projectScopeById(id) {
        if (id == null) return '';
        let result = this.projectScopes.find(x => x.id == id);
        if (!result) return '';
        return result.name;
      },
      hourbookingTypeById(id) {
        let result = this.hourbookingTypes.find(x => x.id == id);
        if (!result) return '';
        return result.name;
      },
      copyClipboard(text) {
        try {
          if (!text) return;
          this.$nextTick(() => {
            navigator.clipboard.writeText(text);
          });
          this.$root.$emit('display-message', '\'' + text + '\' gekopieerd naar klembord', 'info');
        }
        catch (err) {
          console.log(err); /* eslint-disable-line no-console */
        }
      },
      setToken() {
        authentication.acquireToken().then(token => {
          this.$http.defaults.headers.common['Authorization'] = `Bearer ${token ? token : ""}`
          this.tokenExpire = authentication.getTokenExpiration();
          // Do not let Graph's hidden-iframe renewal block the API-backed portal startup
          this.getProfileData()
          authentication.acquireToken('https://graph.microsoft.com').then(graphToken => {
            this.graphToken = graphToken
            this.getProfileImage()
          })
            .catch((e) => {
              console.log('graphtoken error!') /* eslint-disable-line no-console */
              console.log(e) /* eslint-disable-line no-console */
            })
        })
          .catch((e) => {
            console.log('token error!') /* eslint-disable-line no-console */
            console.log(e) /* eslint-disable-line no-console */
          });
      },
      refreshToken() {
        return authentication.acquireToken().then(token => {
          this.$http.defaults.headers.common['Authorization'] = `Bearer ${token ? token : ""}`
          this.tokenExpire = authentication.getTokenExpiration();
          return token;
        });
      }
    },
    mounted() {
      this.$on('display-message', (code, msg, type) => {
        if (type == "error") {
          if (msg.response && msg.response.data) this.dialogMessage = msg.response.data;
          else this.dialogMessage = msg;
          this.dialogErrorCode = code;
        }
      });
      this.$on('display-message', (msg, type) => {
        if (type == "info") {
          this.dialogMessage = msg
        }
      });
      this.$on('toggleDrawer', (state) => {
        this.appDrawer = state;
      });
      try {
        this.isPrinting = printMediaQuery.matches;
        printMediaQuery.addEventListener('change', (e) => {
          this.isPrinting = e.matches;
        });
      }
      catch (err) {
        console.warn('failed to monitor mediatype', err); /* eslint-disable-line no-console */
      }
      this.setToken();
    }
  }).$mount('#app')
})